<template>
    <CollapsibleWidget>
        <template #name>Sizes</template>
        <template #controls>
            <Badge
                v-if="creativeLibraryFiltersStore.selectedSizes.length"
                :count="creativeLibraryFiltersStore.selectedSizes.length"
                class="filter-badge-count"
            ></Badge>
        </template>
        <LibraryCheckboxGroup v-model="creativeLibraryFiltersStore.selectedSizes" :options="options" />
    </CollapsibleWidget>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useStore } from "vuex";

import LibraryCheckboxGroup from "@/components/Campaign/LibraryCheckboxGroup.vue";
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { useCreativeLibraryFiltersStore } from "@/store/pinia/creativeLibraryFilters";
import type { RootState } from "@/store/types";

const store = useStore<RootState>();
const creativeLibraryFiltersStore = useCreativeLibraryFiltersStore();

const options = computed(() => store.state.deliverableLibrary.filterOptions.masterTemplates);
</script>

<style lang="scss">
@use "@style/variables" as *;
</style>
